import Vue from 'vue';
import Router from 'vue-router';
import { permissionCheck } from '@/utils/router';

const DashboardLayout = () => import('./layouts/Dashboard.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      meta: {},
      component: () =>
        import(/* webpackChunkName: "Auth" */ './views/Auth.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/Dashboard.vue'),
    },
    {
      path: '/settings/profile',
      name: 'editProfile',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/Profile/Profile.vue'
        ),
    },
    {
      path: '/settings/password',
      name: 'editPassword',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/Profile/Password.vue'
        ),
    },
    {
      path: '/shops',
      name: 'shops',
      meta: {
        auth: true,
        permission: ['superadmin'],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/Shop/landing.vue'),
    },
    {
      path: '/shop/new',
      name: 'createShop',
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ['superadmin'],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/Shop/Shop.vue'),
    },
    {
      path: '/shop/:id',
      name: 'editShop',
      meta: {
        auth: true,
        action: 'shop/find',
        layout: DashboardLayout,
        permission: ['superadmin'],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/Shop/Shop.vue'),
    },
    {
      path: '/medias',
      name: 'medias',
      meta: {
        auth: true,
        permission: ['superadmin'],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/Media/landing.vue'),
    },
    {
      path: '/users',
      name: 'users',
      meta: {
        auth: true,
        permission: ['superadmin', 'admin', 'customer'],
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/User/landing.vue'),
    },
    {
      path: '/user/new',
      name: 'createUser',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/User/User.vue'),
    },
    {
      path: '/user/:id/profile',
      name: 'editUser',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/User/User.vue'),
    },
    {
      path: '/user/:id/points',
      name: 'userPoints',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/User/Points.vue'),
    },
    {
      path: '/user/:id/password',
      name: 'editUserPassword',
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ['superadmin'],
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/User/Password.vue'),
    },
    {
      path: '/user/:id/media',
      name: 'editUserMedia',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/User/Media.vue'),
    },
    {
      path: '/systemSettings/medicalCondition',
      name: 'medicalConditions',
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ['superadmin'],
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/SystemSettings/MedicalCondition.vue'
        ),
    },
    {
      path: '/systemSettings/scalpCondition',
      name: 'scalpConditions',
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ['superadmin'],
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/SystemSettings/ScalpCondition.vue'
        ),
    },
    {
      path: '/systemSettings/MediaTag',
      name: 'mediaTags',
      meta: {
        auth: true,
        layout: DashboardLayout,
        permission: ['superadmin'],
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/SystemSettings/MediaTag.vue'
        ),
    },
    {
      path: '/redeemables',
      name: 'redeemables',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/Redeemable/landing.vue'
        ),
    },
    {
      path: '/redeemable/new',
      name: 'createRedeemable',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/Redeemable/Redeemable.vue'
        ),
    },
    {
      path: '/redeemable/:id/edit',
      name: 'editRedeemable',
      meta: {
        auth: true,
        action: 'redeemable/find',
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/Redeemable/Redeemable.vue'
        ),
    },
    {
      path: '/reward-templates',
      name: 'rewardTemplates',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/RewardTemplate/landing.vue'
        ),
    },
    {
      path: '/reward-template/new',
      name: 'createRewardTemplate',
      meta: {
        auth: true,
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/RewardTemplate/RewardTemplate.vue'
        ),
    },
    {
      path: '/reward-template/:id/edit',
      name: 'editRewardTemplate',
      meta: {
        auth: true,
        action: 'rewardTemplate/find',
        layout: DashboardLayout,
      },
      component: () =>
        import(
          /* webpackChunkName: "Dashboard" */ './views/RewardTemplate/RewardTemplate.vue'
        ),
    },
  ],
});

router.beforeEach(permissionCheck);

export default router;
